import { createActionGroup, props } from '@ngrx/store';
import { Vacancy } from '@mkp/vacancy/models';
import { Location } from '@mkp/location/models';

export const vacancyFormPageActions = createActionGroup({
  source: 'Vacancy Form Page',
  events: {
    'Set Default Company Profile': props<{ companyId: string }>(),
    'Update Vacancy': props<{ vacancy: Vacancy }>(),
    'Select Location': props<{ location: Location }>(),
  },
});
